module.exports = __webpack_public_path__ + "img/logo.4b4bc162.svg";